@if (snackbar) {
  <div class="snackbar-container" [ngClass]="snackbar.position || 'top-center'">
    <div class="snackbar-content" [ngClass]="snackbar.type" [@snackbarAnimation]="getAnimationParams()">
      <div class="snackbar-icon">
        @if (snackbar.type === 'success') {
          <hugeicons-icon [icon]="successIcon" [size]="24" color="currentColor"></hugeicons-icon>
        }
        @if (snackbar.type === 'error') {
          <hugeicons-icon [icon]="errorIcon" [size]="24" color="currentColor"></hugeicons-icon>
        }
        @if (snackbar.type === 'info') {
          <hugeicons-icon [icon]="infoIcon" [size]="24" color="currentColor"></hugeicons-icon>
        }
        @if (snackbar.type === 'warning') {
          <hugeicons-icon [icon]="warningIcon" [size]="24" color="currentColor"></hugeicons-icon>
        }
      </div>
      <div class="snackbar-message">{{ snackbar.message }}</div>
      <button class="snackbar-close" (click)="close()" aria-label="Close">
        <hugeicons-icon [icon]="closeIcon" [size]="20" color="currentColor"></hugeicons-icon>
      </button>
    </div>
  </div>
}